import React from "react";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import { dbFormatDate, formatToStandardDate, standardFormatToday } from "../../../api_calls/utils";
import { StickyTopRowStack } from "../../../components/commonComponents/StyledComponents/styled";
import MetricSwap from "../filters/MetricSwap";
import StoreFilter from "../../../components/commonComponents/Filters/StoreFilter";
import DateRangeInputFields from "../../../components/commonComponents/Filters/DateRangeInputFields";
import SingleSelectStoreFilter from "../../../components/commonComponents/Filters/SingleSelectStoreFilter";
import AnalysisGroup from "../filters/shared/AnalysisGroup";
import AnalysisGroupSingle from "../filters/shared/AnalysisGroupSingle";
import RankByFilter from "../../../components/commonComponents/Filters/RankByFilter";
import MarketingFilters from "../filters/MarketingFilters";
import Regions from "../filters/shared/RegionsFilter";
import NielsenRegionsFilter from "../filters/shared/NielsenRegionsFilter";
import CampaignStoresFilter from "../filters/shared/CampaignStoresFilter";
import CampaignStoreSingleSelectFilter from "../filters/shared/CampaignStoreSingleSelectFilter";
import CheckoutDataFilter from "../../../components/commonComponents/Filters/CheckoutDataFilter";
import ImpressionFormat from "../../../components/commonComponents/Filters/ImpressionFormat";

const FilterMarkup = ({ filterConfig, reduxKeywordToSaveValue, configTabName, campaignStartDate, campaignEndDate, regionFilterEnabled, nielsenRegionFilterEnabled }) => {
    {/* ---------- Metrics Filter ---------- */ }
    if (filterConfig.keyword === "AbsolutePercentage") {
        return (
            <Box sx={{ width: 70 }}>
                <MetricSwap
                    reduxKeywordToSaveValue={reduxKeywordToSaveValue}
                    redux_param_name={configTabName.replace(" ", "_") + "_absolute_percentage"}
                />
            </Box>
        );
    }
    {/* ------- stores filter (MultiSelect) ----------- */ }
    if (filterConfig.keyword === "Stores" && filterConfig.type === "multiSelect") {
        return (
            <Box sx={{ width: 220 }}>
                <CampaignStoresFilter
                    reduxKeywordToSaveValue={reduxKeywordToSaveValue}
                    filterParamRegionName={configTabName.replace(" ", "_") + "_selected_region_name"}
                    filterParamNielsenRegionCode={configTabName.replace(" ", "_") + "_selected_nielsen_regions"}
                    regionFilterEnabled={regionFilterEnabled}
                    nielsenRegionFilterEnabled={nielsenRegionFilterEnabled}
                />
            </Box>
        )
    }
    {/* ------- stores filter (SingleSelect) ----------- */ }
    if (filterConfig.keyword === "Stores" && filterConfig.type === "singleSelect") {
        return (
            <Box sx={{ width: 220 }}>
                <CampaignStoreSingleSelectFilter
                    reduxKeywordToSaveValue={reduxKeywordToSaveValue}
                    filterParamRegionName={configTabName.replace(" ", "_") + "_selected_region_name"}
                    filterParamNielsenRegionCode={configTabName.replace(" ", "_") + "_selected_nielsen_regions"}
                    regionFilterEnabled={regionFilterEnabled}
                    nielsenRegionFilterEnabled={nielsenRegionFilterEnabled}
                />
            </Box>
        )
    }
    {/* ------------ day timestamp filter ------------ */ }
    if (filterConfig.keyword === "Date" && filterConfig.type === "dateRange") {
        return (
            <Box
                sx={{
                    "& .MuiFormHelperText-root:not(.Mui-error)": {
                        display: "none",
                    },
                }}
            >
                <DateRangeInputFields
                    minSelectableDate={campaignStartDate}
                    maxSelectableDate={campaignEndDate}
                    reduxKeywordToSaveValue={reduxKeywordToSaveValue}
                />
            </Box>
        );
    }
    {/* ------------ Analysis Group (multiselect) ------------ */ }
    if (filterConfig.keyword === "AnalysisGroup" && filterConfig.type === "multiSelect") {
        return (
            <Box sx={{ width: 220 }}>
                <AnalysisGroup
                    reduxKeywordToSaveValue={reduxKeywordToSaveValue}
                    redux_param_name={configTabName.replace(" ", "_") + "_selected_analysis_group"}
                    multiSelect={true}
                />
            </Box>
        );
    }
    {/* ------------ Analysis Group (single select) ------------ */ }
    if (filterConfig.keyword === "AnalysisGroup" && filterConfig.type === "singleSelect") {
        return (
            <Box sx={{ width: 220 }}>
                <AnalysisGroupSingle reduxKeywordToSaveValue={reduxKeywordToSaveValue} redux_param_name={configTabName.replace(" ", "_") + "_selected_analysis_group"} multiSelect={false} />
            </Box>
        );
    }
    {/* ---------- Rank By ---------- */ }
    if (filterConfig.keyword === "RankBy") {
        return (
            <Box sx={{ width: 220 }}>
                <RankByFilter reduxKeywordToSaveValue={reduxKeywordToSaveValue} />
            </Box>
        );
    }

    // ------ marketing activity ---------- 
    if (filterConfig.keyword === "Activity") {
        return (
            <Box sx={{ width: 220 }}>
                <MarketingFilters reduxKeywordToSaveValue={reduxKeywordToSaveValue} redux_param_name={configTabName.replace(" ", "_") + "_marketing_activity"} />
            </Box>
        );
    }

    if (filterConfig.keyword === "Activity Type") {
        return (
            <Box sx={{ width: 220 }}>
                <MarketingFilters enabledFor="activity_type_dropdown" reduxKeywordToSaveValue={reduxKeywordToSaveValue} redux_param_name={configTabName.replace(" ", "_") + "_marketing_activity"} />
            </Box>
        );
    }

    // ------ regions filter ---------- 
    if (filterConfig.keyword === "Regions") {
        return (
            <Box sx={{ width: 220 }}>
                <Regions
                    reduxKeywordToSaveValue={reduxKeywordToSaveValue} redux_param_name={configTabName.replace(" ", "_") + "_selected_region_name"}
                    filterParamNielsenRegionCode={configTabName.replace(" ", "_") + "_selected_nielsen_regions"}
                    nielsenRegionFilterEnabled={nielsenRegionFilterEnabled}
                />
            </Box>
        );
    }

    // nielsen regions filter
    if (filterConfig.keyword === "Nielsen Regions") {
        return (
            <Box sx={{ width: 220 }}>
                <NielsenRegionsFilter
                    reduxKeywordToSaveValue={reduxKeywordToSaveValue}
                    redux_param_name={configTabName.replace(" ", "_") + "_selected_nielsen_regions"}
                    paramToSaveFilteredRegion={configTabName.replace(" ", "_") + "_selected_region_name"}
                />
            </Box>
        );
    }

    {/* ---------- Rank By ---------- */ }
    if (filterConfig.keyword === "Checkout Data") {
        return (
            <Box sx={{ width: 220 }}>
                <CheckoutDataFilter reduxKeywordToSaveValue={reduxKeywordToSaveValue} redux_param_name={configTabName.replace(" ", "_") + "_checkout_data"} />
            </Box>
        );
    }

    // Impression format filter
    if (filterConfig.keyword === "absoluteButton") {
        console.log(reduxKeywordToSaveValue);
        return (
            <Box sx={{ width: 220 }}>
                <ImpressionFormat reduxKeywordToSaveValue={reduxKeywordToSaveValue} redux_param_name={configTabName.replace(" ", "_") + "_impression_format"} />
            </Box>
        );
    }

    // show clips boolean
    // if (filterConfig.keyword === "ShowClips") {
    //     return (
    //         <Box sx={{ width: 220, marginTop: "10px" }}>
    //             <ShowClipBoolean reduxKeywordToSaveValue={reduxKeywordToSaveValue} redux_param_name={configTabName.replace(" ", "_") + "_show_clip_filter"} />
    //         </Box>
    //     );
    // }

    // if (filterConfig.keyword === "IdClip") {
    //     return (
    //         <Box sx={{ width: 220, marginTop: "10px" }}>
    //             <IdClipFilter reduxKeywordToSaveValue={reduxKeywordToSaveValue} redux_param_name={configTabName.replace(" ", "_") + "_idClip_filter"} />
    //         </Box>
    //     );
    // }

    // if (filterConfig.keyword === "IdPicture") {
    //     return (
    //         <Box sx={{ width: 220, marginTop: "10px" }}>
    //             <IdPictureFilter reduxKeywordToSaveValue={reduxKeywordToSaveValue} redux_param_name={configTabName.replace(" ", "_") + "_idPicture_filter"} />
    //         </Box>
    //     );
    // }

    // if (filterConfig.keyword === "Status") {
    //     return (
    //         <Box sx={{ width: 220, marginTop: "10px" }}>
    //             <InfraStatusFilter reduxKeywordToSaveValue={reduxKeywordToSaveValue} redux_param_name={configTabName.replace(" ", "_") + "_status_filter"} />
    //         </Box>
    //     );
    // }
}

const Filters = ({ configArr, configTabName, configTabType }) => {
    const campaignDetails = useSelector((state) => state.userSelections);

    //Filter should load AFTER fetching is done to prevent Retailer Filters to Persist
    if (campaignDetails.brand_filters_loading === true) {
        return <></>;
    }

    const reduxKeywordToSaveValue = configTabType === "impression" ? "embedded_impression_filter" : "embedded_performance_filter";

    const campaignStartDate =
        typeof campaignDetails.campaign_detail !== "undefined" ? campaignDetails.campaign_detail.campaign_start_date : "";

    const today = standardFormatToday();
    const yesterday = formatToStandardDate(today);
    yesterday.setDate(today.getDate() - 1);

    const campaignEndDate =
        typeof campaignDetails.campaign_detail !== "undefined" &&
            campaignDetails.campaign_detail.campaign_active_status !== "Active"
            ? campaignDetails.campaign_detail.campaign_end_date
            : dbFormatDate(yesterday);

    const regionFilterEnabled = configArr.some(filterOpt => filterOpt.keyword === "Regions");
    const nielsenRegionFilterEnabled = configArr.some(filterOpt => filterOpt.keyword === "Nielsen Regions");

    return configArr.length !== 0 ? (
        <>
            <StickyTopRowStack direction="row"
                sx={{
                    marginRight: "20px",
                    flexWrap: "wrap",   // allow items to wrap
                    position: "sticky", // ensures stickiness
                    top: 0,
                    zIndex: 10,
                    backgroundColor: "white", // so wrapped rows don’t overlap content
                    padding: "10px 0",
                    rowGap: "16px",
                    flexDirection: "row-reverse",
                    justifyContent: "flex-start",
                    gap: 3,
                    alignItems: "center",
                    // "& > *": {
                    //     minWidth: "200px", // 👈 adjust this as needed
                    // },
                }}
            >
                {
                    configArr.map((filterConfig, index) => (
                        <FilterMarkup
                            key={configTabName.replace(" ", "_") + "__" + filterConfig.keyword + "__" + index}
                            filterConfig={filterConfig}
                            reduxKeywordToSaveValue={reduxKeywordToSaveValue}
                            configTabName={configTabName}
                            campaignStartDate={campaignStartDate}
                            campaignEndDate={campaignEndDate}
                            regionFilterEnabled={regionFilterEnabled}
                            nielsenRegionFilterEnabled={nielsenRegionFilterEnabled}
                        />
                    ))
                }
            </StickyTopRowStack>
        </>
    ) : (<></>);
};

export default Filters;
